<template lang="pug">
include /mixins
+b.trip-distribution-condition-message(
  :style="{ '--bg': message.bg }"
)
  +e.content
    +e.title.P {{ message.title }} &nbsp;
      span(v-if='message.hasSum' v-html='getSplittedHtml(message.sum(), currency)')
    +e.after_text.P(
      :style="{ '--color': message.color }"
    ) {{ message.after_text }} &nbsp;
      span(v-if='message.hasAfterSum' v-html='getSplittedHtml(message.afterSum(), currency)')

</template>

<script>

import {
  mapState, mapActions,
} from 'vuex'

import pathOr from 'ramda/src/pathOr'

const FUTURE_MONTH_STATUS = 'future'
const CURRENT_MONTH_STATUS = 'current'
const PAST_MONTH_STATUS = 'past'

const ZERO = 0

const HAS_DEPT = 'bad'
const IS_OK = 'good'
const IS_PERFECT = 'perfect'

export default {
  props: {
    condition: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      currency: window.currency,
      messages: {
        [HAS_DEPT]: {
          title: this._('Цього місяця треба докупити на'),
          text: this._('Для того, щоб виконати умови цього місяця Вам треба докупити ще на'),
          after_text: this._('включно з боргом'),
          img: HAS_DEPT,
          hasSum: true,
          hasAfterSum: true,
          sum: item => this.getDebt(item),
          afterSum: item => this.getOldDebt(item),
          color: 'var(--theme-secondary-orange)',
          bg: '#FFF4E6',
        },
        [IS_OK]: {
          title: this._('Ви молодець, умови цього місяця виконані'),
          img: IS_OK,
          hasSum: true,
          hasAfterSum: false,
          color: 'var(--theme-primary-green)',
          bg: '#D9F6EE',
        },
      },
    };
  },
  computed: {
    ...mapState('trip', ['trip']),
    list() {
      return pathOr({}, this.path, this.trip);
    },
    hasDebt() {
      return this.condition.props.monthly_distribution.find(e => e.status === PAST_MONTH_STATUS && e.balance < ZERO)
    },
    isOk() {
      return this.condition.props.monthly_distribution.find(e => e.status === CURRENT_MONTH_STATUS && e.balance < ZERO)
    },
    isPerfect() {
      return this.condition.props.monthly_distribution.find(e => e.status === CURRENT_MONTH_STATUS && e.balance === ZERO)
    },
    message() {
      // eslint-disable-next-line no-nested-ternary
      const val = this.isPerfect ? IS_PERFECT : (this.isOk && !this.hasDebt ? IS_OK : HAS_DEPT)
      return this.messages[val]
    },
  },
  methods: {
    ...mapActions('trip', ['getTrip']),
    getDebt() {
      if (!this.trip.conditions) return 0;
      // const debt = Math.abs(this.trip.conditions
      //   .reduce((acc, curr) => acc + curr.props.monthly_distribution.findLast(e => e.status === PAST_MONTH_STATUS).balance, 0))

      const debt = Math.abs(this.trip.conditions
        .reduce((acc, curr) => {
          let current = curr.props.monthly_distribution.find(e => e.status === CURRENT_MONTH_STATUS)
          if (!current) {
            current = curr.props.monthly_distribution.findLast(e => e.status === PAST_MONTH_STATUS)
          }
          if ((Math.abs(current.balance) - current.monthly_purchase) > ZERO) {
            acc += current.balance
          }
          return acc
        }, 0))
      // const debt = Math.abs(this.trip.conditions
      //   .reduce((acc, curr) => acc + curr.props.monthly_distribution
      //     .reduce((acc2, curr2) => {
      //       if (curr2.status === PAST_MONTH_STATUS) {
      //         acc2 += curr2.balance
      //       }
      //       return acc2
      //     }, 0), 0))
      const alreadyPaid = Math.abs(this.trip.conditions
        .reduce((acc, curr) => {
          let current = curr.props.monthly_distribution.find(e => e.status === CURRENT_MONTH_STATUS)
          if (!current) {
            current = curr.props.monthly_distribution.findLast(e => e.status === PAST_MONTH_STATUS)
          }
          // if ((Math.abs(current.balance) - current.monthly_purchase) > ZERO) {
          // }
          acc += current.monthly_purchase
          return acc
        }, 0))
      // const alreadyPaid = Math.abs(this.trip.conditions
      //   .reduce((acc, curr) => acc + curr.props.monthly_distribution
      //     .reduce((acc2, curr2) => {
      //       if (curr2.status === CURRENT_MONTH_STATUS) {
      //         acc2 += curr2.monthly_purchase
      //       }
      //       return acc2
      //     }, 0), 0))

      return debt
    },
    getOldDebt() {
      if (!this.trip.conditions) return 0;
      const alreadyPaid = Math.abs(this.trip.conditions
        .reduce((acc, curr) => {
          let current = curr.props.monthly_distribution.find(e => e.status === CURRENT_MONTH_STATUS)
          if (!current) {
            current = curr.props.monthly_distribution.findLast(e => e.status === PAST_MONTH_STATUS)
          }
          // if ((Math.abs(current.balance) - current.monthly_purchase) > ZERO) {
          // }
          acc += current.monthly_purchase
          return acc
        }, 0))
      return alreadyPaid
    },
    getActual() {
      if (!this.trip.conditions) return 0;
      const alreadyPaid = Math.abs(this.trip.conditions
        .reduce((acc, curr) => {
          let current = curr.props.monthly_distribution.find(e => e.status === CURRENT_MONTH_STATUS)
          if (!current) {
            current = curr.props.monthly_distribution.findLast(e => e.status === PAST_MONTH_STATUS)
          }
          if (current.monthly_purchase > Math.abs(current.balance)) {
            acc += current.monthly_purchase - Math.abs(current.balance)
          }
          return acc
        }, 0))
      return alreadyPaid
    },
    getFuture() {
      if (!this.trip.conditions) return 0;
      const alreadyPaid = Math.abs(this.trip.conditions
        .reduce((acc, curr) => {
          let current = curr.props.monthly_distribution.find(e => e.status === FUTURE_MONTH_STATUS)
          if (!current) {
            current = curr.props.monthly_distribution.findLast(e => e.status === CURRENT_MONTH_STATUS)
          }
          if (current.monthly_purchase > Math.abs(current.balance)) {
            acc += current.monthly_purchase - Math.abs(current.balance)
          }
          return acc
        }, 0))
      return alreadyPaid
    },
  },
}

</script>
